var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'places-view', params: { placeId: _vm.place.id } }},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.place.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }